import { render } from "./add-group-modal.vue?vue&type=template&id=5af536c0"
import script from "./add-group-modal.vue?vue&type=script&lang=js"
export * from "./add-group-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__